<template>
    <page-layout bg-background="black">
        <b-card no-body class="login-card">
            <slot></slot>
        </b-card>
    </page-layout>
</template>
<script>
import { defineComponent } from 'vue';
import PageLayout from '@components/Layout/PageLayout.vue';
import { useUserStore } from '@stores/User';
import { useAppStore } from '@stores/App';

export default defineComponent({
    components: {
        PageLayout,
    },
    unmounted() {
        this.toggleBodyClass(false);
    },
    mounted() {
        this.toggleBodyClass(true);
    },
    methods: {
        toggleBodyClass: function (add) {
            const app = useAppStore();
            const user = useUserStore();

            /**
             * @var VueRoute path
             */
            const path = user?.redirect_to?.fullPath || this.$route.fullPath;

            let specialLoginStyle = null;
            if (path?.includes('wedding')) {
                specialLoginStyle = 'wedding';
            }

            if (path?.includes('christmas')) {
                specialLoginStyle = 'christmas';
            }

            if (path?.includes('black-week')) {
                specialLoginStyle = 'black-week';
            }

            if (add) {
                app.pageClasses.add('login-page');
                app.pageClasses.add(specialLoginStyle);
            } else {
                app.pageClasses.delete('login-page');
                app.pageClasses.delete(specialLoginStyle);
            }

            if (specialLoginStyle) {
                app.setTheme(specialLoginStyle);
            }
        },
    }
});
</script>
<style lang="scss" scoped>
@import "@app/_breakpoints.scss";

.login-header {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    background: white;
    height: 80px;
}

.login-card {
    background: white;
    margin: auto;
    width: 100%;
    max-width: 400px;
    border-radius: 0;
    border: 0;

    &--init {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
}
::v-global(.login-page main) {
    background: #080808 !important;
    background-image: url(/images/login/bg-default.jpg) !important;
    box-shadow: inset 0 0 0 100vmax rgba(0, 0, 0, 0.2);
}

::v-global(.login-page.wedding main) {
    background-image: url(/images/login/bg-wedding.jpg) !important;
    background-repeat: no-repeat !important;
    box-shadow: inset 0 0 0 100vmax rgba(0, 0, 0, 0.2);

    @include respond-to("md") {
        background-size: cover !important;
        background-position: center !important;
    }
}

::v-global(.login-page.christmas main) {
    background-image: url(/images/login/bg-christmas.jpg) !important;
    background-repeat: no-repeat !important;
    box-shadow: inset 0 0 0 100vmax rgba(0, 0, 0, 0.2);

    @include respond-to("md") {
        background-size: cover !important;
        background-position: center !important;
    }
}

::v-global(.login-page header) {
    background: white;
    margin-bottom: 0rem;
}

::v-global(.login-page .content) {
    padding: 1.5rem;
    margin-bottom: 10rem;
}

::v-global(.login-page .content) {
    padding: 1.5rem;
    margin-bottom: 10rem;
}

::v-global(.login-page .page-footer) {
    margin-top: 0 !important;
    padding-top: 0 !important;
}

::v-global(.login-page .footer-content) {
    max-width: 100% !important;
}
</style>
